import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '../../../filters/translate.pipe';

@Component({
	standalone: true,
	selector: 'toolkit-overview',
	templateUrl: './toolkit-overview.component.html',
	imports: [CommonModule, FormsModule, TranslatePipe]
})
export class ToolkitOverviewComponent {
	@Input() vm: any;

	progressPercent(done: number, total: number): number {
		if (!total || total <= 0) return 0;
		return Math.max(0, Math.min(100, Math.round((done / total) * 100)));
	}

	progressFillClass(done: number, total: number): string {
		const pct = this.progressPercent(done, total);
		if (pct <= 0) return 'fill-gray';
		if (pct >= 100) return 'fill-green';
		return 'fill-orange';
	}

		statusPill(summary: any): { cls: string; key: string; count?: number } {
			const key = (summary?.statusKey || 'ACTIVE').toString().toUpperCase();
			if (key === 'NEW') return { cls: 'pill-new', key: 'Toolkit.Status.NewClient' };
			if (key === 'DONE') return { cls: 'pill-done', key: 'Toolkit.Status.Done' };
			if (key === 'OVERDUE') {
				const n = Number(summary?.overdueCount || 0);
				const count = isFinite(n) && n > 0 ? n : undefined;
				return { cls: 'pill-overdue', key: 'Toolkit.Status.Overdue', count };
			}
			return { cls: 'pill-active', key: 'Toolkit.Status.Active' };
		}
}
